module.exports = __webpack_public_path__ + "static/media/ic_success.b96f4859.svg";